import React from 'react'
import { NavLink } from 'react-router-dom'

export const Nav = () => {
  const activeStyle = {
    textDecoration: 'none',
    borderBottom: 'solid',
  }
  const styleDict = { textDecoration: 'none' }
  const classes = 'px-5 py-3 text-dark'
  return (
    <div style={{ marginBottom: '4em' }}>
      <NavLink
        exact
        to={`/account/invoice_account_enrollment/reporting/`}
        activeStyle={activeStyle}
        style={styleDict}
        className={classes}
        isActive={() => window.location.pathname.includes('/reporting')}
      >
        Reporting
      </NavLink>
      <NavLink
        exact
        to={`/account/invoice_account_enrollment/invoice_accounts/`}
        activeStyle={activeStyle}
        style={styleDict}
        className={classes}
      >
        Invoice Accounts
      </NavLink>
    </div>
  )
}
